export default {
	namespaced: true,
	state: {
		currentUser: null,
		tokenChecked: false,
	},
	mutations: {
		TOKEN_CHECK(state) {
			state.tokenChecked = true
		},
		RESET_USER_DATA(state) {
			state.currentUser = null
			state.tokenChecked = false
		},
		SET_USER_DATA(state, data) {
			state.currentUser = data
			state.tokenChecked = true
		},
		UPDATE_USER_DATA(state, data) {
			for (let key in data) {
				const data_item = data[key]
				if (data_item !== undefined) {
					state.currentUser[key] = data_item
				}
			}
		},
		UPDATE_USER_SETTINGS(state, data) {
			state.currentUser.settings = data
		},
	},
	actions: {
		tokenCheck({ commit }) {
			commit('TOKEN_CHECK')
		},
		resetUserData({ commit }) {
			commit('RESET_USER_DATA')
		},
		setUserData({ commit }, data) {
			commit('SET_USER_DATA', data)
		},
		updateUserDate({ commit }, data) {
			commit('UPDATE_USER_DATA', data)
		},
		updateUserSettings({ commit }, data) {
			commit('UPDATE_USER_SETTINGS', data)
		},
	}
}